import { render, staticRenderFns } from "./BaseButtonUpload.vue?vue&type=template&id=3594a015"
import script from "./BaseButtonUpload.vue?vue&type=script&lang=js"
export * from "./BaseButtonUpload.vue?vue&type=script&lang=js"
import style0 from "./BaseButtonUpload.vue?vue&type=style&index=0&id=3594a015&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports